import { ProductFormatEnum } from '../../../../../store/apiLibx';
import { TFunction } from 'i18next';
import { InputDropdownOptions } from '../../../shared/LCFormFieldInputDropdown';

export const mapProductFormat = (
    productFormat: ProductFormatEnum | undefined,
    t: TFunction
): InputDropdownOptions<ProductFormatEnum> => {
    return {
        current: productFormat,
        all: [
            { key: ProductFormatEnum.PDF, value: t('yourLocalContent.yourTitles.dropdowns.productFormat.PDF') },
            { key: ProductFormatEnum.EPUB, value: t('yourLocalContent.yourTitles.dropdowns.productFormat.EPUB') }
        ]
    };
};
